import {
  doSectionSpecificActionsAndsaveFormData,
  reValidateSection,
} from 'AppSrc/core/data-structures/data-utility-functions';
import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import { getCrq } from 'AppSrc/core/crq/crq-queries';
import { generateFormDataFromCrq } from 'AppSrc/core/crq/crq-form-utils';
import { crqWorkItemsFetched } from 'AppSrc/core/work-info-items/work-info-item-actions';
import { deleteAllIndidualList } from 'AppSrc/core/approvers/approver-individual-actions';
// import dataaction from './dataaction.json';


const FETCH_CRQ_VIEW_EDIT_REQUEST = 'FETCH_CRQ_VIEW_EDIT_REQUEST';
const FETCH_CRQ_VIEW_EDIT_SUCCESS = 'FETCH_CRQ_VIEW_EDIT_SUCCESS';
const FETCH_CRQ_VIEW_EDIT_ERROR = 'FETCH_CRQ_VIEW_EDIT_ERROR';

const SAVE_EDIT_FORM_DATA = 'SAVE_EDIT_FORM_DATA';
const SET_RISK_VALUE_FOR_EDIT_FORM = 'SET_RISK_VALUE_FOR_EDIT_FORM';
const SAVE_SECTION_DATA_FOR_EDIT_FORM = 'SAVE_SECTION_DATA_FOR_EDIT_FORM';
const CHANGE_COORDINATOR_FOR_EDIT_CRQ_ID = 'CHANGE_COORDINATOR_FOR_EDIT_CRQ_ID';
const CHANGE_STATUS_REASON_FOR_EDIT_CRQ_ID = 'CHANGE_STATUS_REASON_FOR_EDIT_CRQ_ID';
const CHANGE_STATUS_FOR_EDIT_CRQ_ID = 'CHANGE_STATUS_FOR_EDIT_CRQ_ID';
const CHANGE_PEER_REJECTION_REASON_FOR_EDIT_CRQ = 'CHANGE_PEER_REJECTION_REASON_FOR_EDIT_CRQ';
const SET_PEER_REVIEWER_GROUP_FOR_EDIT_CRQ_ID = 'SET_PEER_REVIEWER_GROUP_FOR_EDIT_CRQ_ID';
const SET_PEER_REVIEWER_FOR_EDIT_CRQ_ID = 'SET_PEER_REVIEWER_FOR_EDIT_CRQ_ID';

const SUBMIT_EDIT_FORM_REQUEST = 'SUBMIT_EDIT_FORM_REQUEST';
const SUBMIT_EDIT_FORM_SUCCESS = 'SUBMIT_EDIT_FORM_SUCCESS';
const SUBMIT_EDIT_FORM_ERROR = 'SUBMIT_EDIT_FORM_ERROR';
const CLEAR_SUBMIT_EDIT_FORM_ERROR = 'CLEAR_SUBMIT_EDIT_FORM_ERROR';


const SAVE_EDIT_FORM_SECTION_ERRORS = 'SAVE_EDIT_FORM_SECTION_ERRORS';
const CLEAR_EDIT_FORM_ERRORS = 'CLEAR_EDIT_FORM_ERRORS';

const MARK_EDIT_SECTION_AS_READ = 'MARK_EDIT_SECTION_AS_READ';
const CLEAR_EDIT_SECTIONS_READ = 'CLEAR_EDIT_SECTIONS_READ';
const SET_SPONSOR_EDIT_FORM = 'SET_SPONSOR_EDIT_FORM';
const SET_UNSAVED_RELATIONSHIPS_EDIT_FORM = 'SET_UNSAVED_RELATIONSHIPS_EDIT_FORM';

// this should probably be deleted one day. But it is super useful for dev
const HACK_BOI_FOR_APPROVERS_ACTIONABLE = 'HACK_BOI_FOR_APPROVERS_ACTIONABLE';

// This constant is for fetching remedy reference crq data
const FETCH_REMEDY_REFERENCE_CRQ_REQUEST = 'FETCH_REMEDY_REFERENCE_CRQ_REQUEST';
const FETCH_REMEDY_REFERENCE_CRQ = 'FETCH_REMEDY_REFERENCE_CRQ';
const FETCH_REMEDY_REFERENCE_CRQ_SUCCESS = 'FETCH_REMEDY_REFERENCE_CRQ_SUCCESS';
const FETCH_REMEDY_REFERENCE_CRQ_ERROR = 'FETCH_REMEDY_REFERENCE_CRQ_ERROR';
const CLEAR_REMEDY_REFERENCE_CRQ_ERROR = 'CLEAR_REMEDY_REFERENCE_CRQ_ERROR';

// set and clear related coordinator id
const SET_RELATED_COORDINATOR_ID = 'SET_RELATED_COORDINATOR_ID';
const CLEAR_RELATED_COORDINATOR_ID = 'CLEAR_RELATED_COORDINATOR_ID';

// clear rmedy ref from formdata
const CLEAR_ADJACENT_REMEDY_REF = 'CLEAR_ADJACENT_REMEDY_REF';

const fetchCrqForViewEditRequest = (crqId) => ({
  type: FETCH_CRQ_VIEW_EDIT_REQUEST,
  payload: {
    crqId,
  },
});

const fetchCrqForViewEditSuccess = (crqId) => ({
  type: FETCH_CRQ_VIEW_EDIT_SUCCESS,
  payload: {
    crqId,
  },
});

const fetchCrqForViewEditError = (crqId, error) => ({
  type: FETCH_CRQ_VIEW_EDIT_ERROR,
  payload: {
    crqId,
    error,
  },
});

const saveEditFormSectionErrorsAction = (params = {}) => {
  const {
    crqId,
    sectionId,
    errors,
  } = params;

  return ({
    type: SAVE_EDIT_FORM_SECTION_ERRORS,
    payload: {
      crqId,
      sectionId,
      errors,
    },
  });
};




const clearEditFormErrorsAction = (crqId) => ({
  type: CLEAR_EDIT_FORM_ERRORS,
  payload: {
    crqId,
  },
});



const submitEditFormRequest = (crqId) => ({
  type: SUBMIT_EDIT_FORM_REQUEST,
  payload: {
    crqId,
  },
});

const submitEditFormSuccess = (crqId) => ({
  type: SUBMIT_EDIT_FORM_SUCCESS,
  payload: {
    crqId,
  },
});

const submitEditFormError = (crqId, error) => ({
  type: SUBMIT_EDIT_FORM_ERROR,
  payload: {
    crqId,
    error,
  },
});

const markEditSectionAsRead = (crqId, sectionId) => ({
  type: MARK_EDIT_SECTION_AS_READ,
  payload: {
    crqId,
    sectionId,
  },
});

const clearEditSectionsRead = (crqId) => ({
  type: CLEAR_EDIT_SECTIONS_READ,
  payload: {
    crqId,
  },
});

const setSponsorEditForm = ({ crqId, sponsor }) => ({
  type: SET_SPONSOR_EDIT_FORM,
  payload: {
    crqId,
    sponsor,
  },
});

// NOTE, this action is not yet consumed by the reducer.
// This will be implemented as part of https://ocasta.atlassian.net/browse/VTO-832
const setUnsavedRelationshipsEditForm = ({ crqId, unsavedRelationships }) => ({
  type: SET_UNSAVED_RELATIONSHIPS_EDIT_FORM,
  payload: {
    crqId,
    unsavedRelationships,
  },
});


const clearSubmitEditFormError = (crqId) => ({
  type: CLEAR_SUBMIT_EDIT_FORM_ERROR,
  payload: {
    crqId,
  },
});


/* ------ ACTION CREATORS ------ */

const saveEditFormDataAction = (crqId, formData) => ({
  type: SAVE_EDIT_FORM_DATA,
  payload: {
    crqId,
    formData,
  },
});

const setRiskValueForEditForm = (params = {}) => {
  const {
    crqId,
    riskValue,
  } = params;

  return ({
    type: SET_RISK_VALUE_FOR_EDIT_FORM,
    payload: {
      crqId,
      riskValue,
    },
  });
};
const saveSectionDataForEditForm = (params) => {
  const {
    crqId,
    sectionData,
  } = params;
  return ({
    type: SAVE_SECTION_DATA_FOR_EDIT_FORM,
    payload: {
      crqId,
      sectionData,
    },
  });
};



const changeCoordinatorForEditCrqId = (params) => {
  const {
    crqId,
    groupName,
    coordinatorId,
    coordinatorName,
  } = params;

  return ({
    type: CHANGE_COORDINATOR_FOR_EDIT_CRQ_ID,
    payload: {
      crqId,
      groupName,
      coordinatorId,
      coordinatorName,
    },
  });
};


const setPeerReviewerGroupForEditCrqId = (params) => {
  const {
    crqId,
    groupName,
  } = params;

  return ({
    type: SET_PEER_REVIEWER_GROUP_FOR_EDIT_CRQ_ID,
    payload: {
      crqId,
      groupName,
    },
  });
};

const setPeerReviewerForEditCrqId = (params) => {
  const {
    crqId,
    id,
    name,
  } = params;

  return ({
    type: SET_PEER_REVIEWER_FOR_EDIT_CRQ_ID,
    payload: {
      crqId,
      id,
      name,
    },
  });
};

const changeStatusReasonForEditCrqId = ({
  crqId,
  statusReason,
}) => ({
  type: CHANGE_STATUS_REASON_FOR_EDIT_CRQ_ID,
  payload: {
    crqId,
    statusReason,
  },
});

const changeStatusForEditCrqId = ({
  crqId,
  status,
}) => ({
  type: CHANGE_STATUS_FOR_EDIT_CRQ_ID,
  payload: {
    crqId,
    status,
  },
});


const changePeerRejectionReasonForEditCrqId = ({
  crqId,
  peerRejectionReason,
}) => ({
  type: CHANGE_PEER_REJECTION_REASON_FOR_EDIT_CRQ,
  payload: {
    crqId,
    peerRejectionReason,
  },
});


const hackBoiForApproversActionable = (crqId) => ({
  type: HACK_BOI_FOR_APPROVERS_ACTIONABLE,
  payload: {
    crqId,
  },
});


const fetchRemedyRefCrqForViewRequest = (crqId) => ({
  type: FETCH_REMEDY_REFERENCE_CRQ_REQUEST,
  payload: {
    crqId,
  },
});

const fetchRemedyRefCrqForSuccess = (crqId) => ({
  type: FETCH_REMEDY_REFERENCE_CRQ_SUCCESS,
  payload: {
    crqId,
  },
});

const fetchRemedyRefCrqForError = (error) => ({
  type: FETCH_REMEDY_REFERENCE_CRQ_ERROR,
  payload: {
    error,
  },
});

const clearRemedyRefCrqForError = () => ({
  type: CLEAR_REMEDY_REFERENCE_CRQ_ERROR,
  payload: {
  },
});

const saveRemedyRefFormDataAction = (crqId, formData) => ({
  type: FETCH_REMEDY_REFERENCE_CRQ,
  payload: {
    crqId,
    formData,
  },
});


// set related vine coordinator
const setRelatedCoordinatorID = (relId) => ({
  type: SET_RELATED_COORDINATOR_ID,
  payload: {
    relId,
  },
});

// clear related vine coordinator
const clearRelatedCoordinatorID = () => ({
  type: CLEAR_RELATED_COORDINATOR_ID,
  payload: {
  },
});

// clear remedy ref from data
const clearAdjacentRemedyRefFromFormData = (crqId) => ({
  type: CLEAR_ADJACENT_REMEDY_REF,
  payload: {
    crqId,
  },
});

// FN: 29/04/2020:
// we have an action called changeCoordinatorForEditCrqId which takes in the same params as changePeerReviewForEditCrqId (this action)
// Both of these actions are called in the same place. The only difference is we already have two actions that combined, have the same
// affect as changePeerReviewForEditCrqId (this action). As such we use this action to call both of them with the same params as
// changeCoordinatorForEditCrqId to keep things consistant.
const changePeerReviewForEditCrqId = (params) => (dispatch, getState) => {
  const {
    crqId,
    groupName,
    coordinatorId,
    coordinatorName,
  } = params;


  dispatch(setPeerReviewerGroupForEditCrqId({
    crqId,
    groupName,
  }));

  dispatch(setPeerReviewerForEditCrqId({
    crqId,
    id: coordinatorId,
    name: coordinatorName,
  }));
};

const sharedActions = {
  saveSectionAction: saveSectionDataForEditForm,
  setRiskValue: setRiskValueForEditForm,
  setSponsor: setSponsorEditForm,
  setUnsavedRelationships: setUnsavedRelationshipsEditForm,
};

const saveEditFormDataThunk = (crqId, formData, validateFormData, editingStatus) => (dispatch, getState) => {
  if (!validateFormData) {
    dispatch(saveEditFormDataAction(crqId, formData));
    return null;
  }


  const state = getState();
  const userRoles = state.auth.user.roles;

  // saves data into redux before validating it
  dispatch(saveEditFormDataAction(crqId, formData));


  // If we are refreshing the data in the store we want to make sure that no errors are still stored!
  dispatch(clearEditFormErrorsAction(crqId)); // <- this *might* not be needed but we cannot test it until the server gives us back updated data



  formData.formSectionsByDisplayOrder.forEach((sectionIdFromArray, index) => {

    // The section data to revalidate (and save)
    const sectionDataToRevalidate = formData.dataByFormSectionId[sectionIdFromArray];
    const newState = getState();
    const newFormData = newState.editForm.formDataById[crqId];

    // some sectionSpecificActions can cause whole sections of the form to no longer be necessary.
    const sectionIsStillInForm = newState.editForm.formDataById[crqId].formSectionsByDisplayOrder.includes(sectionIdFromArray);


    if (sectionIsStillInForm) {
      reValidateSection({
        formId: CREATE_CRQ,
        crqId,
        formData: newFormData,
        sectionData: sectionDataToRevalidate,
        dispatch,
        userRoles,
        editingStatus,
        network: newFormData.network,
        actions: {
          ...sharedActions,
          saveFormSectionErrorsAction: saveEditFormSectionErrorsAction,
        },
      });
    }
  });

  return null;

};


// saves the sectionData and performs any section specific actions
const saveSectionDataForEditFormThunk = (params) => (dispatch, getState) => {
  const {
    crqId,
    sectionData,
    editingStatus,
  } = params;

  const state = getState();
  const userRoles = state.auth.user.roles;
  const currentFormData = state.editForm.formDataById[crqId];

  doSectionSpecificActionsAndsaveFormData({
    formId: CREATE_CRQ,
    crqId,
    sectionData,
    dispatch,
    currentFormData,
    editingStatus,
    userRoles,
    actions: {
      ...sharedActions,
    },
  });
};


const fetchCrqForRemedyRef = (
  crqId,
  network,
) => (dispatch, getState) => {
  dispatch(fetchRemedyRefCrqForViewRequest(crqId));

  return getCrq(network, crqId).then(
    (response) => {
      const { crq } = response;
      dispatch(clearRemedyRefCrqForError());
      dispatch(saveRemedyRefFormDataAction(crqId, crq));
      dispatch(fetchRemedyRefCrqForSuccess(crqId));
    },
  ).catch((error) => {
    // success action we use to just set fecting flag to false
    dispatch(fetchRemedyRefCrqForSuccess(crqId));
    dispatch(fetchRemedyRefCrqForError(error));
    return Promise.reject(error);
  });
};

const fetchCrqForViewEdit = ({
  editingStatus,
  crqId,
  network,
  shouldFetchRemRef,
}) => (dispatch, getState) => {
  dispatch(fetchCrqForViewEditRequest(crqId));
  const hasIndividual = getState().individualApproverList.ApproversList;
  if (hasIndividual.length > 0) {
    // To delete individual approver list
    dispatch(deleteAllIndidualList());
  }
  const userRoles = getState().auth.user.roles;
  return getCrq(network, crqId).then(
    (response) => {
      const { crq, workInfoItems } = response;
      const crqFormData = generateFormDataFromCrq({
        crq,
        workInfoItems,
        userRoles,
      });
      // fetch ref crq calling dispatch related-remedy-action get
      // eslint-disable-next-line camelcase
      const adjacentRemedyRef = crq.adjacent_remedy_ref;
      if (((adjacentRemedyRef !== null) && (adjacentRemedyRef !== undefined)) && shouldFetchRemRef === true) {
        const inverseNetwork = network === 'fixed' ? 'mobile' : 'fixed';
        dispatch(fetchCrqForRemedyRef(adjacentRemedyRef, inverseNetwork));
      }
      // we should always validate the data when fetching a crq
      // whether the logged in user can see the errors is determined by the display components
      const shouldValidate = true;
      dispatch(crqWorkItemsFetched(crqId, workInfoItems));
      dispatch(saveEditFormDataThunk(crqId, crqFormData, shouldValidate, editingStatus));
      dispatch(fetchCrqForViewEditSuccess(crqId));
    },
  ).catch((error) => {
    dispatch(fetchCrqForViewEditError(crqId, error));
    return Promise.reject(error);
  });
};


export {
  FETCH_CRQ_VIEW_EDIT_REQUEST,
  FETCH_CRQ_VIEW_EDIT_SUCCESS,
  FETCH_CRQ_VIEW_EDIT_ERROR,
  SAVE_EDIT_FORM_DATA,
  SET_RISK_VALUE_FOR_EDIT_FORM,
  SAVE_SECTION_DATA_FOR_EDIT_FORM,
  CHANGE_COORDINATOR_FOR_EDIT_CRQ_ID,
  CHANGE_STATUS_REASON_FOR_EDIT_CRQ_ID,
  CHANGE_STATUS_FOR_EDIT_CRQ_ID,
  CHANGE_PEER_REJECTION_REASON_FOR_EDIT_CRQ,
  SUBMIT_EDIT_FORM_REQUEST,
  SUBMIT_EDIT_FORM_SUCCESS,
  SUBMIT_EDIT_FORM_ERROR,
  CLEAR_SUBMIT_EDIT_FORM_ERROR,
  SAVE_EDIT_FORM_SECTION_ERRORS,
  CLEAR_EDIT_FORM_ERRORS,
  MARK_EDIT_SECTION_AS_READ,
  CLEAR_EDIT_SECTIONS_READ,
  SET_PEER_REVIEWER_FOR_EDIT_CRQ_ID,
  SET_PEER_REVIEWER_GROUP_FOR_EDIT_CRQ_ID,
  SET_SPONSOR_EDIT_FORM,
  SET_UNSAVED_RELATIONSHIPS_EDIT_FORM,
  HACK_BOI_FOR_APPROVERS_ACTIONABLE,
  FETCH_REMEDY_REFERENCE_CRQ,
  FETCH_REMEDY_REFERENCE_CRQ_REQUEST,
  FETCH_REMEDY_REFERENCE_CRQ_SUCCESS,
  FETCH_REMEDY_REFERENCE_CRQ_ERROR,
  CLEAR_REMEDY_REFERENCE_CRQ_ERROR,
  SET_RELATED_COORDINATOR_ID,
  CLEAR_RELATED_COORDINATOR_ID,
  CLEAR_ADJACENT_REMEDY_REF,
  fetchCrqForViewEditRequest,
  fetchCrqForViewEditSuccess,
  fetchCrqForViewEditError,
  markEditSectionAsRead,
  clearEditSectionsRead,
  saveEditFormDataAction,
  saveEditFormDataThunk,
  saveSectionDataForEditFormThunk,
  saveSectionDataForEditForm,
  changeCoordinatorForEditCrqId,
  changeStatusReasonForEditCrqId,
  changeStatusForEditCrqId,
  changePeerRejectionReasonForEditCrqId,
  submitEditFormRequest,
  submitEditFormSuccess,
  submitEditFormError,
  clearSubmitEditFormError,
  setPeerReviewerGroupForEditCrqId,
  setPeerReviewerForEditCrqId,
  changePeerReviewForEditCrqId,
  setSponsorEditForm,
  setUnsavedRelationshipsEditForm,
  hackBoiForApproversActionable,
  fetchCrqForViewEdit,
  fetchCrqForRemedyRef,
  saveRemedyRefFormDataAction,
  fetchRemedyRefCrqForError,
  clearRemedyRefCrqForError,
  fetchRemedyRefCrqForSuccess,
  fetchRemedyRefCrqForViewRequest,
  setRelatedCoordinatorID,
  clearRelatedCoordinatorID,
  clearAdjacentRemedyRefFromFormData,
};

